import { render, staticRenderFns } from "./CampoCredibancoTramas.vue?vue&type=template&id=50b3b80c&scoped=true"
import script from "./CampoCredibancoTramas.vue?vue&type=script&lang=js"
export * from "./CampoCredibancoTramas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b3b80c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50b3b80c')) {
      api.createRecord('50b3b80c', component.options)
    } else {
      api.reload('50b3b80c', component.options)
    }
    module.hot.accept("./CampoCredibancoTramas.vue?vue&type=template&id=50b3b80c&scoped=true", function () {
      api.rerender('50b3b80c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/administration/components/tef/components/Credibanco/CampoCredibancoTramas.vue"
export default component.exports